import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const UPDATE_ALL_PARTNER_OPT_OUT = gql`
  mutation UpdateAllPartnerOptOutMutation($input: Boolean!) {
    updateAllPartnerOptOut(input: $input)
  }
`;

export default function useAllPartnerOptOutUpdate() {
  const [updateAllPartnerOptOut, { error, loading }] = useMutation(UPDATE_ALL_PARTNER_OPT_OUT, {
    noThrow: true
  });

  const saveAllPartnerOptOut = useCallback(
    async (event, onCompleted) => {
      event.preventDefault();

      await updateAllPartnerOptOut({
        variables: {
          input: true
        }
      });

      if (onCompleted) {
        onCompleted();
      }
    },
    [updateAllPartnerOptOut]
  );

  useError(error);

  return {
    hasError: Boolean(error),
    loading,
    saveAllPartnerOptOut
  };
}
